﻿export class response_booking_info_payment {
    public method: string = "";
    public net_gross: string = "";
}